import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { PurchaseOrder } from '../../../../../models/PurchaseOrder';
import { VendorService } from '../../../../../services/vendor.service';

@Component({
  selector: 'app-po-detail',
  templateUrl: './po-detail.component.html',
  styleUrls: ['./po-detail.component.scss']
})
export class PoDetailComponent implements OnInit, OnChanges, OnDestroy {
  @Input() PONumber: string;
  poDetails: PurchaseOrder;
  alive = true;
  constructor(private vendorSvc: VendorService) { }

  ngOnInit() {
    if (this.PONumber) {
      this.getPODetails(this.PONumber);
    }
  }

  ngOnChanges(changes: any) {
    this.PONumber = changes.PONumber.currentValue;
    if (this.PONumber) {
      this.getPODetails(this.PONumber);
    }
  }

  getPODetails(poNumber: string) {
    this.vendorSvc.getPODetails(poNumber).takeWhile(() => this.alive).subscribe(
      data => {
      this.poDetails = data;
    });
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/vendor/my-vendor/purchase-order-view/po-detail/po-detail.component.ts